import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteEndpoint } from '../../../../actions';

const EndpointDeleteButton = ({
  dispatchDeleteEndpoint,
  endpointId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteEndpoint({ endpointId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

EndpointDeleteButton.propTypes = {
  dispatchDeleteEndpoint: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  endpointId: PropTypes.number.isRequired,
};

EndpointDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteEndpoint: deleteEndpoint,
};

export default connect(null, mapDispatchToProps)(EndpointDeleteButton);
